import React from 'react'
import { Stack, Typography } from '@mui/joy'

type Props = {
  subtitle?: string
  title?: string
}

const HeaderTitle = ({
  subtitle,
  title,
}: Props) => {
  return (
    <Stack>
      {
        subtitle &&
        <Typography level='body-sm'>{subtitle}</Typography>
      }
      <Typography level='h2'>{title}</Typography>
    </Stack>
  )
}

export default HeaderTitle